export const SUPPORTED_LOCALES = ["pt", "en", "es", "fr"];
export const DEFAULT_LOCALE = "pt";

export const isSupportedLocale = (value) =>
  SUPPORTED_LOCALES.includes((value || "").toLowerCase());

export const normalizeLocale = (value) =>
  isSupportedLocale(value) ? value.toLowerCase() : DEFAULT_LOCALE;

export const getLocaleFromPathname = (pathname = "/") => {
  const [firstSegment] = pathname.split("/").filter(Boolean);
  return isSupportedLocale(firstSegment) ? firstSegment.toLowerCase() : null;
};

export const stripLocaleFromPathname = (pathname = "/") => {
  const locale = getLocaleFromPathname(pathname);

  if (!locale) {
    return pathname || "/";
  }

  const stripped = pathname.replace(new RegExp(`^/${locale}(?=/|$)`), "");
  return stripped || "/";
};

export const getPathSegments = (pathname = "/") =>
  stripLocaleFromPathname(pathname).split("/").filter(Boolean);

export const removeTrailingSlash = (path = "/") => {
  if (path === "/") return "/";
  return path.replace(/\/+$/, "") || "/";
};

export const withLocalePath = (path = "/", locale = DEFAULT_LOCALE) => {
  const normalizedLocale = normalizeLocale(locale);
  const [pathnamePart = "/", suffix = ""] = String(path).split(/(?=[?#])/);
  const normalizedPath = pathnamePart.startsWith("/") ? pathnamePart : `/${pathnamePart}`;
  const basePath = stripLocaleFromPathname(normalizedPath);

  if (basePath === "/") {
    return `/${normalizedLocale}${suffix}`;
  }

  return `/${normalizedLocale}${removeTrailingSlash(basePath)}${suffix}`;
};

export const getLocalizedUrl = (siteUrl, path, locale) => {
  const normalizedSiteUrl = (siteUrl || "").replace(/\/+$/, "");
  return `${normalizedSiteUrl}${withLocalePath(path, locale)}`;
};
